import PubSub from "underpub-js";

var PopupAmenity = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-PopupAmenity',
	};

	$.extend(true, this.options, options);

};

PopupAmenity.prototype.init = function() {

	var self = this;

};

export default PopupAmenity;
